import React from 'react';
import { trackCtaClick } from '../../../utils/gtm';

export const SWITCHING_SERVICE = 'Bookkeeping: Switching from my accountant';

const AnnouncementBar = ({ onOpenModal }) => (
  <div className="bk-announce" role="region" aria-label="Announcement">
    <div className="bk-container bk-announce-row">
      <span>Switching accountants? We collect your records from the old one and take over within 14 days.</span>
      <button
        type="button"
        className="bk-announce-cta gtm-cta-btn"
        data-gtm-id="announcement-get-quote"
        id="announcementQuoteBtn"
        onClick={() => {
          trackCtaClick('announcement_get_quote');
          onOpenModal(SWITCHING_SERVICE);
        }}
      >
        Get a quote →
      </button>
    </div>
  </div>
);

export default AnnouncementBar;
